var _tspan, _rect, _tspan2, _g, _g2, _tspan3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg09L27R(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113 140.35)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("text", {
    x: 13.86202,
    y: 253.8631,
    fill: "#000000",
    fontFamily: "Raleway",
    fontSize: "5.3333px",
    fontWeight: 300,
    letterSpacing: "0px",
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 13.86202,
    y: 258.80008
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.95597 0 0 .95597 8.0923 -27.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.86988 0 0 .86988 20.762 10.493)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -321.35,
    y: 134.19,
    width: 240.53,
    height: 25.187,
    ry: 0.32091,
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 0.36074
  })), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-.52446)",
    x: 144.0704,
    y: 302.228,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "4.8098px",
    letterSpacing: "0px",
    strokeWidth: 0.36074,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 144.0704,
    y: 302.228,
    fill: "#ffffff",
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif",
    fontSize: "13.468px",
    fontWeight: 600,
    strokeWidth: 0.36074,
    "text-align": "center",
    textAnchor: "middle"
  }, "9"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -320.62,
    y: 135.19,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -320.62,
    y: 139.25,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -320.62,
    y: 143.3,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -320.62,
    y: 147.36,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -320.62,
    y: 151.41,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -320.62,
    y: 151.41,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -320.62,
    y: 155.47,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m145.85 126.59h1.8045v-10.823h-1.8045zm0 14.43h1.8045v-10.823h-1.8045zm0 14.43h1.8045v-10.823h-1.8045zm0 14.432h1.8045v-10.824h-1.8045zm0 14.43h1.8045v-10.823h-1.8045zm0 14.43h1.8045v-10.823h-1.8045zm0 14.43h1.8045v-10.823h-1.8045zm0 14.43h1.8045v-10.823h-1.8045zm0 14.432h1.8045v-10.823h-1.8045zm0 14.43h1.8045v-10.823h-1.8045zm0 14.43h1.8045v-10.823h-1.8045zm0 14.43h1.8045v-10.823h-1.8045z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    enableBackground: "accumulate",
    fill: "#fffbfb",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -96.932,
    y: 135.24,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -96.932,
    y: 139.29,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -96.932,
    y: 143.35,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -96.932,
    y: 147.4,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -96.932,
    y: 151.46,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -96.932,
    y: 151.46,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -96.932,
    y: 155.51,
    width: 14.986,
    height: 2.9636,
    ry: 0.48557
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(179.48)",
    x: -145.83543,
    y: -101.86958,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontSize: "4.8098px",
    letterSpacing: "0px",
    strokeWidth: 0.36074,
    wordSpacing: "0px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: -145.83543,
    y: -101.86958,
    fill: "#ffffff",
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif",
    fontSize: "13.468px",
    fontWeight: 600,
    strokeWidth: 0.36074,
    "text-align": "center",
    textAnchor: "middle"
  }, "27"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09L27R);
export default __webpack_public_path__ + "static/media/09L_27R.1f61afdb18e260566bf21c63807d4bca.svg";
export { ForwardRef as ReactComponent };